import React from 'react'

const GlobalSourcing = () => {
    return (
        <div>
            <h1>Global Sourcing</h1>
        </div>
    )
}

export default GlobalSourcing